/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProductSubscription} from '../models/ProductSubscription';
import type {UpdateProductAccessTermRequest} from '../models/UpdateProductAccessTermRequest';

export interface GetProductSubscription$Request {
    productSubscriptionId: string;
}

export interface GetProductSubscription$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductSubscriptionRequest = createAction<PayloadData<void, GetProductSubscription$Request>>('PRODUCT_SUBSCRIPTION__GET_PRODUCT_SUBSCRIPTION__REQUEST');
export const getProductSubscriptionSuccess = createAction<PayloadData<ProductSubscription, GetProductSubscription$Request>>('PRODUCT_SUBSCRIPTION__GET_PRODUCT_SUBSCRIPTION__SUCCESS');
export const getProductSubscriptionFailure = createAction<PayloadData<Error, GetProductSubscription$Request, true>>('PRODUCT_SUBSCRIPTION__GET_PRODUCT_SUBSCRIPTION__FAILURE');

export const getProductSubscriptionActions = [
    getProductSubscriptionRequest,
    getProductSubscriptionSuccess,
    getProductSubscriptionFailure
] as const;

/**
 * @param {string} meta.productSubscriptionId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductSubscription = (meta: GetProductSubscription$Request, config?: GetProductSubscription$Config) => {
    return {
        CALL_API: {
            types: getProductSubscriptionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product-subscriptions/${meta.productSubscriptionId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateProductAccessTerm$Request {
    productSubscriptionId: string;
    updateProductAccessTermRequest: UpdateProductAccessTermRequest;
}

export interface UpdateProductAccessTerm$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateProductAccessTermRequest = createAction<PayloadData<void, UpdateProductAccessTerm$Request>>('PRODUCT_SUBSCRIPTION__UPDATE_PRODUCT_ACCESS_TERM__REQUEST');
export const updateProductAccessTermSuccess = createAction<PayloadData<void, UpdateProductAccessTerm$Request>>('PRODUCT_SUBSCRIPTION__UPDATE_PRODUCT_ACCESS_TERM__SUCCESS');
export const updateProductAccessTermFailure = createAction<PayloadData<Error, UpdateProductAccessTerm$Request, true>>('PRODUCT_SUBSCRIPTION__UPDATE_PRODUCT_ACCESS_TERM__FAILURE');

export const updateProductAccessTermActions = [
    updateProductAccessTermRequest,
    updateProductAccessTermSuccess,
    updateProductAccessTermFailure
] as const;

/**
 * @param {string} meta.productSubscriptionId
 * @param {UpdateProductAccessTermRequest} meta.updateProductAccessTermRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateProductAccessTerm = (meta: UpdateProductAccessTerm$Request, config?: UpdateProductAccessTerm$Config) => {
    return {
        CALL_API: {
            types: updateProductAccessTermActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product-subscriptions/${meta.productSubscriptionId}`,
            TRANSPORT_REQUEST_BODY: meta.updateProductAccessTermRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

